import { type Permission } from '@/modules/auth/permissions';
import {
  hasAnyPermission,
  hasPermissions,
} from '@/modules/auth/utils/hasPermissions';
import { useCurrentUserQuery } from '@/modules/users/queries/useCurrentUserQuery';

/**
 * Wrapper around `hasPermissions` to check if the user has the given permissions
 */
export const useCheckPermissions = () => {
  const currentUserQuery = useCurrentUserQuery();
  const userPermissions = currentUserQuery.data?.permissions || [];

  const hasUserPermission = (permissions: Permission[]) => {
    return hasPermissions(permissions, userPermissions);
  };

  return hasUserPermission;
};

/**
 * Wrapper around `hasAtLeastOnePermission` to check if the user has at least one of the given permissions
 */
export const useCheckAnyPermission = () => {
  const currentUserQuery = useCurrentUserQuery();
  const userPermissions = currentUserQuery.data?.permissions || [];

  const hasUserAtLeastOnePermission = (permissions: Permission[]) => {
    return hasAnyPermission(permissions, userPermissions);
  };

  return hasUserAtLeastOnePermission;
};
